var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTemplate = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "currentColor",
  viewBox: "0 0 280 280"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M240 40c11.046 0 20 8.954 20 20v160c0 11.046-8.954 20-20 20H40c-11.046 0-20-8.954-20-20V60c0-11.046 8.954-20 20-20zm-50 40H90c-5.523 0-10 4.477-10 10v10c0 5.523 4.477 10 10 10h35v80c0 5.523 4.477 10 10 10h10c5.523 0 10-4.477 10-10v-80h35c5.523 0 10-4.477 10-10V90c0-5.523-4.477-10-10-10"
})));
export default SvgTemplate;